// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"ap-z","badgeLink":"bp-z","category":"cp-z"};